export default "__VITE_ASSET__DIeHUTId__"